import React from "react";
import { ThemeProvider } from "styled-components";

import { H1 } from "../styles/styledComponents/elements";
import Themed from "../helpers/Themed";

export const renderTitleSpan = (data, theme, size) => {
  return data.titleSpan.map(title =>
    renderTitle(title.titlePartial, theme, size)
  )
}

const renderTitle = (title, theme, size) => {
  if (theme === "alt") {
    return (<Themed alt>
      <H1><span>{title}</span></H1>
    </Themed>
    );
  }
  return (<Themed>
    <H1 mobileFontSize={size}><span>{title}</span></H1>
  </Themed>
  )
}


// WEBPACK FOOTER //
// ./src/helpers/renderTitleSpan.js